/**
 * Loads the Ask My Website AI widget on the Orbit CRM demo, keys-from-env style
 * (mirrors apps/atlantic-solar): the backend serves `/orbit-crm/demo-keys.js` which
 * sets `window.AIG_DEMO`, and this turns it into a single `<script>` injection.
 *
 * Înlocuiește vechiul snippet hardcodat din index.html (app-id de prod, sdk.js de
 * prod) — care pe staging vorbea cu botul de producție. Acum app-id-ul vine per
 * mediu din DEMO2_APP_ID, iar SDK-ul se încarcă de pe app.<mediu>.
 *
 * Guarded so a script tag is never injected twice and a missing config never
 * surfaces an error to the visitor.
 */
declare global {
  interface Window {
    AIG_DEMO?: { appId?: string; publicKey?: string };
  }
}

const MARKER_ATTR = "data-orbit-crm-ai-widget";

export function initAIIntegrationLoader(): void {
  try {
    if (document.querySelector(`script[${MARKER_ATTR}]`)) return;

    const keys = window.AIG_DEMO;
    if (!keys?.appId || !keys?.publicKey) return;

    const script = document.createElement("script");
    const isLocal = location.hostname === "localhost" || location.hostname === "127.0.0.1";
    // Deduce originea API din host-ul demo-ului: `demo2.<rest>` → `app.<rest>`.
    // demo2.staging.askmywebsiteai.com → app.staging... (SDK de pe staging, NU prod);
    // demo2.askmywebsiteai.com → app.askmywebsiteai.com. Local: aceeași origine
    // (backend la /sdk.js). Fără asta, apiBase ar deveni demo2. și /v1 s-ar rescrie
    // la /orbit-crm/v1 → 404.
    const apiOrigin = isLocal
      ? location.origin
      : `${location.protocol}//${location.hostname.replace(/^[^.]+/, "app")}`;
    script.src = `${apiOrigin}/sdk.js`;
    script.dataset.appId = keys.appId;
    script.dataset.publicKey = keys.publicKey;
    // Sit de demo al casei: întrebările merg pe /v1/demo/ask cu cookie de sesiune.
    script.dataset.demo = "true";
    script.setAttribute(MARKER_ATTR, "true");
    script.addEventListener("error", () => {
      // Fail silently — a missing/broken widget script must never break the site.
    });
    document.body.appendChild(script);
  } catch {
    // Never let widget loading break the page.
  }
}
